import { useState, useCallback } from 'react'

import { styled } from 'styled-components'

import { Banner, FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { Colors, Typography } from '@b-stock/fe-core/design-system'

const BannerWrapper = styled(Banner)`
  margin-bottom: 1.5rem;
`

const Title = styled.div`
  ${Typography.Subtitle1}
  color: ${Colors.Semantic.Neutral.black};
  margin-bottom: 0.25rem;
`

const Message = styled.div`
  ${Typography.Body2}
  color: ${Colors.Semantic.Neutral.very_dark_grey};
`

export const PaymentRestrictionBanner = ({
  achUnavailable = false,
  suppressAddMethodSuggestion = false,
}: {
  achUnavailable?: boolean
  suppressAddMethodSuggestion?: boolean
}) => {
  const [isDismissed, setIsDismissed] = useState(false)
  const onDismiss = useCallback(() => setIsDismissed(true), [])

  if (isDismissed) return null

  return (
    <BannerWrapper type="info" onDismiss={onDismiss}>
      <Title>
        <FormattedMessage
          id={
            achUnavailable
              ? 'BlockedAchCheckout.title'
              : 'PaymentRestriction.title'
          }
        />
      </Title>
      <Message>
        <FormattedMessage
          id={
            achUnavailable
              ? 'BlockedAchCheckout.message'
              : suppressAddMethodSuggestion
                ? 'BlockedAchAddMethod.otherRestrictions'
                : 'PaymentRestriction.message'
          }
        />
      </Message>
    </BannerWrapper>
  )
}
